import { jsx as i, jsxs as e } from "react/jsx-runtime";
import { c as r } from "../../index-C7ezJk5b.js";
import "../../base-BUIxijjU.js";
import "react";
import { cssX as d } from "../../core/utils/css.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const h = ({
  className: o,
  isSimple: s,
  size: t
}) => s ? /* @__PURE__ */ i(
  "div",
  {
    className: r(
      d("Loader"),
      "is-simple",
      o
    ),
    style: { width: `${t}px`, height: `${t}px` }
  }
) : /* @__PURE__ */ i("div", { className: r(d("Loader"), o), children: /* @__PURE__ */ e("div", { className: r(d("DotsLoader")), children: [
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {})
] }) });
export {
  h as default
};
